export default "Træn jeres kastefærdigheder! Brug krop og åndedræt, kast til måls og stang ”fisk” med fiskespyd, på bedste jægerstenalder manér!";